import Head from "next/head";

import Brochure from "@/components/ThankYouPage/Brochure";
import Footer from "@/sections/home/Footer";
import Header from "@/sections/home/Header";

export default function BrochureGuiaRentInquilino() {
    return (
        <>
            <Head>
                <title>ThankYouPage Guía Rent Inquilino Brochure | Grupo Guía</title>
                <link
                    rel="canonical"
                    href="https://grupoguia.mx/guiarent-inquilino-brochure-gracias"
                />
                <link
                    rel="alternate"
                    href="https://grupoguia.mx/guiarent-inquilino-brochure-gracias"
                    hrefLang="es-mx"
                />
            </Head>
            <Header />
            <Brochure />
            <Footer />
        </>
    );
}
